const initalState = {
  employeesPromise: null,
  employeeList: [],
  employeeMap: {},
  employeeSort: {
    prop: '',
    isDesc: false
  },
  employeeSearch: {
    searchTerm: '',
    searchedEmployeeList: []
  },
  jobsByEmployee: {}
}

export const employeesReducer = (state = initalState, action) => {
  switch(action.type) {
    case 'FETCH_EMPLOYEES':
      return {
        ...state,
        employeesPromise: null,
        employeeList: [...action.payload],
        employeeMap: [...action.payload].reduce((r, emp) => {
          r[emp.UUID] = emp;
          return r;
        }, {}),
      }
    case 'FETCH_EMPLOYEES_LOADING':
      return{
        ...state,
        employeesPromise: action.payload
      }      
    case 'ADD_EMPLOYEE_SORT': 
      return {
        ...state,
        employeeSort: action.payload
      }
    case 'CREATE_NEW_EMPLOYEE': 
      return {
        ...state,
        employeeList: [...state.employeeList, action.payload],
        employeeSearch: {
          searchTerm: '',
          searchedEmployeeList: []
        }
      }
    case 'UPDATE_EMPLOYEE': 
      return {
        ...state,
        employeeList: state.employeeList.map(employee => employee.UUID === action.payload.id ? {...employee, ...action.payload.employee} : employee),
      }
    case 'ADD_EMPLOYEE_SEARCH':
      return {
        ...state,
        employeeSearch: {
          searchTerm: action.payload.searchTerm,
          searchedEmployeeList: action.payload.searchedEmployeeList
        }
      }
    case 'CLEAR_EMPLOYEE_SEARCH':
      return {
        ...state,
        employeeSearch: {
          searchTerm: '',
          searchedEmployeeList: []
        }
      }
    case 'DELETE_EMPLOYEE':
      return {
        ...state,
        employeeSearch: {
          searchTerm: state.employeeSearch.searchTerm,
          searchedEmployeeList: state.employeeSearch.searchedEmployeeList.filter(employee => employee.UUID !== action.payload.UUID)
        },
        employeeList: state.epmloyeeList.filter(epmloyee => epmloyee.UUID !== action.payload.UUID),
      }
    case 'FETCH_JOBS_BY_EMPLOYEE':
      return {
        ...state,
        jobsByEmployee: {
          ...state.jobsByEmployee,
          [action.payload.employeeId]: action.payload.jobs
        }
      }
    case 'UPDATE_USER':
      return {
        ...state,
        employeeList: [...state.employeeList.map(emp => {
          if (emp.UUID === action.payload.id) {
            return {...emp, ...action.payload.data}
          } else {
            return {...emp};
          }
        })]
      }
    default: 
      return state;
  }
}